
import { MHTTPCL, JSON_STRING, createHttpGetOptions } from "../../../services/http/http-client";
import { CONTACTS_URL, LABEL_URL } from "../../../services/common-urls";
export const licenceAccountsService = {
  

    loadLicenceAccounts:()=>MHTTPCL.get(LABEL_URL,{
        section:"licences",
        action:"load_licence_accounts",
        output:JSON_STRING
    }),
    getLicence:()=>MHTTPCL.get(LABEL_URL,{
        section:"licences",
        output:JSON_STRING
    }),

    //old
    lencAccsList:()=>MHTTPCL.get(LABEL_URL,{
        section:"licences",
        action:"lenc_accs_list",
        output:JSON_STRING
    }),

    //new
    licenceAccountList:(row_start=0,row_count=100,search='',licence_status_id='',licence_account_status_id ='',due=0,active=0)=>MHTTPCL.get(LABEL_URL,{
        section:"licences",
        action:"licence_account_list",
        search:search,
        licence_status_id:licence_status_id,
        licence_account_status_id :licence_account_status_id ,
        due:due,
        active:active,
        row_start:row_start,
        row_count:row_count,
        output:JSON_STRING
    }),

    isLicenceReminderSentout:(licence_account_id)=>MHTTPCL.get(LABEL_URL,{
        section:"licences",
        action:"is_licence_reminder_sentout",
        licence_account_id:licence_account_id,
        output:JSON_STRING
    }),

    licenceAccAdvancedSearchModalData:()=>MHTTPCL.get(LABEL_URL,{
        section:'licences',
        action:'licence_acc_advanced_search_modal_data',
        output:JSON_STRING
    }),

    addLicenceIncomeModal1Data:(licence_account_id,licence_id='')=>MHTTPCL.post(LABEL_URL,{
        section:"licences",
        action:"add_licence_income_modal_1_data",
        licence_id:licence_id,
        licence_account_id:licence_account_id,
      
        output:JSON_STRING
      }),

      addLicenceIncomeModal2Data:({licence_id="",licence_account_id='',date='',text='',currency_id='',invoice_project_id='',year='',period=''})=>MHTTPCL.post(LABEL_URL,{
        section:"licences",
        action:"add_licence_income_modal_2_data",
        licence_id:licence_id,
        licence_account_id,licence_account_id,
        date:date,
        text:text,
        currency_id:currency_id,
        invoice_project_id:invoice_project_id,
        year:year,
        period:period,
        output:JSON_STRING
      }),

      addLicenceIncome:({date="",text="", invoice_project_id="",year="",currency_id="",period="",licence_id="",licence_account_id='',licence_lines=[]})=>MHTTPCL.post(LABEL_URL,{
        section:"licences",
        action:"add_licence_income",
        invoice_project_id:invoice_project_id,
        date:date,
        text:text,
        year:year,
        currency_id:currency_id,
        period:period,
        licence_id:licence_id,
        licence_account_id,licence_account_id,
        licence_lines:JSON.stringify( licence_lines),
        output:JSON_STRING
      }),



      //income

      createInvoiceFromLicenceAccount:(invoice_project_id,licence_line_ids ,licence_account_id)=>MHTTPCL.post(LABEL_URL,{
        section:'licences',
        action:'create_invoice_from_licence_account',
        invoice_project_id:invoice_project_id,
        licence_line_ids :JSON.stringify(licence_line_ids ),
        licence_account_id:licence_account_id,
        output:JSON_STRING
      }),

      

     
      

    

    

    // licenceAccountRows:(start)=>MHTTPCL.post(LABEL_URL,{
    //     section:"licences",
    //     action:"licence_account_rows",
    //     start:	start
    // }),

    searchLcncAccs:(business_status,search="%%%%")=>MHTTPCL.post(LABEL_URL,{
        section:"licences",
        action:"search_lcnc_accs",
        business_status:business_status,
        search:search,
        tableID:"licence_account_Table",
        output:JSON_STRING
    }),

    createLicenceAccount:()=>MHTTPCL.get(LABEL_URL,{
        section:"licences",
        action:"create_licence_account",
        output:JSON_STRING

    }),

    newLicenceAccount:(licence_account_name,keyword,label_status_id)=>MHTTPCL.get(LABEL_URL,{
        section:"licences",
        action:"new_licence_account",
        licence_account_name:licence_account_name,
        keyword:keyword,
        label_status_id:label_status_id
    }),

    removeLicenceAccount:(licence_account_id)=>MHTTPCL.post(LABEL_URL,{
        section:"licences",
        action:"remove_licence_account",
        licence_account_id:licence_account_id
    }),



    //details request

    licenceAccountDetails:(licence_account_id)=>MHTTPCL.get(LABEL_URL,{
        section:"licences",
        action:"licence_account_details",
        licence_account_id:licence_account_id
    }),

    lcncAccDetailsTabOverview:(licence_account_id)=>MHTTPCL.get(LABEL_URL,{
        section:"licences",
        action:"lcnc_acc_details_tab_overview",
        licence_account_id:licence_account_id
    }),

    deleteContactRelation:(contact_relation_id)=>MHTTPCL.post(CONTACTS_URL,{
        action	: "delete_relation",
        contact_relation_id	:contact_relation_id
    }),
    

    lcncAccDetailsTabLicences:(licence_account_id)=>MHTTPCL.get(LABEL_URL,{
        section :"licences",
        action:"lcnc_acc_details_tab_licences",
        licence_account_id:licence_account_id
        
    }),

    lcncAccDetailsTabInvoices:(licence_account_id)=>MHTTPCL.get(LABEL_URL,{
        section:'licences',
        action:'lcnc_acc_details_tab_invoices',
        licence_account_id:licence_account_id

    }),

    invoiceProjects:(licence_account_id)=>MHTTPCL.get(LABEL_URL,{
        section:'licences',
        action:'invoice_projects',
        licence_account_id:licence_account_id,
        output:JSON_STRING
    }),

    createInvoices:(licence_account_id,invoice_project_id,licence_lines)=>MHTTPCL.post(LABEL_URL,{
        section:"licences",
        action:"create_invoices",
        licence_account_id:licence_account_id,
        invoice_project_id:invoice_project_id,
        licence_lines:JSON.stringify(licence_lines)
    }),
    
    // licence

    licenceForm:(licence_id)=>MHTTPCL.get(LABEL_URL,{
        section:"licences",
        action:"licence_form",
        licence_id:licence_id
        
    
    }),

    createRelatedLicenceForm:()=>MHTTPCL.get(LABEL_URL,{
        section:"licences",
        action:"create_related_licence_form",
        licence_account_id:licence_account_id
	
    }),



    removeRelatedLicence:(licence_id,licence_account_id)=>MHTTPCL.post(LABEL_URL,{
        section:"licences",
        action:"remove_related_licence",
        licence_id:licence_id,
        licence_account_id:licence_account_id
    }),
    duplicateLicense:(licence_id,licence_name)=>MHTTPCL.post(LABEL_URL,{
        section:"licences",
        action:"duplicate_license",
        licence_id:licence_id,
        licence_name:licence_name
    }),
    
    


    addRelatedLicence:({licence_account_id,licence_name,licence_usage,label_status_id,exclusivity,territory_id,date_start,term_years,term_month,accounting_period,due_days,currency_id,active_flag})=>MHTTPCL.post(LABEL_URL,{
        action:"add_related_licence",
        licence_account_id:licence_account_id,
        licence_name:licence_name,
        licence_usage:licence_usage,
        label_status_id:label_status_id,
        exclusivity:exclusivity,
        territory_id:territory_id,
        date_start:date_start,
        term_years:term_years,
        term_month:term_month,
        accounting_period:accounting_period,
        due_days:due_days,
        currency_id:currency_id,
        active_flag:active_flag,
        royalty_info:	"Advance:&#10;Royalty+Rate:+xx%+of+XXX&#10;Rata:+1/xx&#10;Deductions:+&#10;Return+Reserve:+&#10;&#10;Digital+Bundle:+xx%&#10;Digital+Track:+xx%",
        internal_notes:	"[++]+Check+outstanding+Invoices+and+Statements&#10;[++]+HOA&#10;[++]+Contract&#10;[++]+Signed&#10;[++]+Advance&#10;[++]+Taxes",
        section:	"licences"
    }),

    loadRelatedLlicences:(licence_account_id)=>MHTTPCL.post(LABEL_URL,{
        section	:"licences",
        action	:"load_related_licences",
        licence_account_id:licence_account_id,
        output:JSON_STRING
    }),

    newLicenceStatementForm1:(licence_account_id)=>MHTTPCL.get(LABEL_URL,{
        section:"licences",
        action:"new_licence_statement_form1",
        licence_account_id:licence_account_id
      
    }),

    newLicenceStatementForm2:({licence_account_id,period_txt,year,currency_id,text,date})=>MHTTPCL.get(LABEL_URL,{
        section:"licences",
        action :"new_licence_statement_form2",
        licence_account_id:licence_account_id,
        period_txt:period_txt,
        year:year,
        currency_id:currency_id,
        text:text,
        date:date
    }),

    newLicenceStatementInvoiceProjectsForm:({licence_account_id,sales_infos,statement_amounts,reserve_amounts,balance_amounts,invoice_amounts,licence_ids,period_txt,year,currency_id,text,date})=>MHTTPCL.get(LABEL_URL,{
        section:"licences",
        action:"new_licence_statement_invoice_projects_form",
        licence_account_id:licence_account_id,
        sales_infos:sales_infos,
        statement_amounts:statement_amounts,
        reserve_amounts:reserve_amounts,
        balance_amounts:balance_amounts,
        invoice_amounts:invoice_amounts,
        licence_ids:licence_ids,
	    period_txt:period_txt,
        year:year,
        currency_id:currency_id,
        text:text,
        date:date

    }),
    newLicenceStatement:({ licence_account_id,sales_infos,statement_amounts,reserve_amounts,balance_amounts,
                           invoice_amounts,licence_ids,period_txt,year,currency_id,text,date,due_days,discount_days,
                           discount_percent ,invoice_ref_key,payment_method_id,money_account_id,invoice_project_id,
                           invoice_date,invoice_user_id,vat_rate3,vat_rate2,vat_rate1,invoice_language
                        })=>MHTTPCL.post(LABEL_URL,{
        section:"licences",
        action:"new_licence_statement",
        licence_account_id:licence_account_id,
        sales_infos:sales_infos,
        statement_amounts:statement_amounts,
        reserve_amounts:reserve_amounts,
        balance_amounts:balance_amounts,
        invoice_amounts:invoice_amounts,
        licence_ids:licence_ids,
        period_txt:period_txt,
        year:year,
        currency_id:currency_id,
        text:text,
        date:date,
        due_days:due_days,
        discount_days:discount_days,
        discount_percent:discount_percent,
        invoice_ref_key:invoice_ref_key,
        payment_method_id:payment_method_id,
        money_account_id:money_account_id,
        invoice_project_id:invoice_project_id,
        invoice_date:invoice_date,
        invoice_user_id:invoice_user_id,
        vat_rate3:vat_rate3,
        vat_rate2:vat_rate2,
        vat_rate1:vat_rate1,
        invoice_language:invoice_language
    }),

    reminderEmail:(licence_account_id)=>MHTTPCL.post(LABEL_URL,{
        section: "licences",
        action: 'reminder_email',
        licence_account_id:licence_account_id,
        output:JSON_STRING  

    }),


    sendReminderEmail:(licence_account_id)=>MHTTPCL.post(LABEL_URL,{
        section: "licences",
        action: 'send_licence_reminder',
        licence_account_id:licence_account_id,
        output:JSON_STRING  

    }),

    //new details FOR related Licence

    licenceAccountRelatedLicences:(licence_account_id,row_start=0,row_count=100)=>MHTTPCL.post(LABEL_URL,{
        section: "licences",
        action: 'licence_account_related_licences',
        licence_account_id:licence_account_id,
        row_start:row_start,
        row_count:row_count,
        output:JSON_STRING
    })



    //section=licences&action=licence_account_related_licences&licence_account_id=74&&row_start=2

    

    

    




    










    
 
	




    
    

   
	
    


  

    
    
    

}
